/**
 * Employee My Timesheet walkthrough (/employee).
 * @module features/walkthrough/tours/employeeTour
 */

import { isMyTimesheetNavVisible } from '../../../navigation/navConfig';
import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep, pageStep } from './navTourHelpers';

const meta = tourMeta('employee-timesheet');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const EMPLOYEE_TOUR = {
  id: 'employee-timesheet',
  title: meta.title,
  description: meta.description,
  roles: ['employee'],
  prerequisiteRoute: navItemPath('my-timesheet') ?? '/employee',
  priority: 20,
  version: 2,
  visible: (user, ctx) =>
    isMyTimesheetNavVisible(user, ctx) && !user?.isProjectManager && !ctx.rmOnlyNav,
  steps: [
    navStep('my-timesheet', {
      title: t('walkthrough.employee.open.title'),
      body: t('walkthrough.employee.open.body'),
    }),
    {
      ...pageStep('timesheet-month-nav', {
        title: t('walkthrough.employee.monthNav.title'),
        body: t('walkthrough.employee.monthNav.body'),
        placement: 'bottom',
      }),
      targetSelector: '[data-walkthrough="timesheet-month-nav-desktop"]',
      mobileSelector: '[data-walkthrough="timesheet-month-nav-mobile"]',
      desktopSelector: '[data-walkthrough="timesheet-month-nav-desktop"]',
    },
    {
      ...pageStep('timesheet-add-entry', {
        title: t('walkthrough.employee.addEntry.title'),
        body: t('walkthrough.employee.addEntry.body'),
        placement: 'top',
      }),
      targetSelector: '[data-walkthrough="timesheet-add-entry-desktop"]',
      mobileSelector: '[data-walkthrough="timesheet-add-entry-mobile"]',
      desktopSelector: '[data-walkthrough="timesheet-add-entry-desktop"]',
    },
    {
      ...pageStep('timesheet-hours-summary', {
        title: t('walkthrough.employee.hoursSummary.title'),
        body: t('walkthrough.employee.hoursSummary.body'),
        placement: 'left',
      }),
      targetSelector: '[data-walkthrough="timesheet-hours-summary-desktop"]',
      mobileSelector: '[data-walkthrough="timesheet-hours-summary-mobile"]',
      desktopSelector: '[data-walkthrough="timesheet-hours-summary-desktop"]',
    },
    {
      ...pageStep('timesheet-submit', {
        title: t('walkthrough.employee.submit.title'),
        body: t('walkthrough.employee.submit.body'),
        placement: 'top',
      }),
      targetSelector: '[data-walkthrough="timesheet-submit-desktop"]',
      mobileSelector: '[data-walkthrough="timesheet-submit-mobile"]',
      desktopSelector: '[data-walkthrough="timesheet-submit-desktop"]',
    },
  ],
};
